import React from "react";
import classnames from "classnames";
import "./styles.less";

export const Input = (props) => {
  const { error = false, className, inputRef, ...restProps } = props;
  const cls = classnames({
    "authing-input": true,
    error: !!error,
    [className]: !!className,
  });
  const componentProps = {
    ...restProps,
    className: cls,
    ref: inputRef,
  };
  return <input {...componentProps}></input>;
};
